// eslint-disable-next-line no-shadow
export enum Styles {
  BRIGHT = 'bright',
  DARK = 'dark',
  DARK2 = 'dark2',
}
